module.exports = __webpack_public_path__ + "build/img/slimy_bot_icon.28ad9283.png";